import { Input, InputProps } from 'antd';

import { getClassName } from '../_utils';

type Props = Pick<
  InputProps,
  'className' | 'disabled' | 'placeholder' | 'style'
> & {
  value: string;
  onChange?: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
};

/**
 * returns JSX for textArea
 */
export function TextArea({
  value,
  className,
  disabled,
  onChange,
  placeholder,
  style,
}: Props) {
  return (
    <Input.TextArea
      value={value}
      className={getClassName('textarea', className)}
      disabled={disabled}
      placeholder={placeholder}
      onChange={onChange}
      style={{ height: 95, resize: 'none', ...style }}
    />
  );
}
